import api from './api';
import { ClassSummary, ClassDetail, CreateClassInput } from '../types/models';

export interface ListClassesParams {
  locationId: string;
  startDate?: string;
  endDate?: string;
  availableOnly?: boolean;
  limit?: number;
}

export async function listClasses(params: ListClassesParams): Promise<ClassSummary[]> {
  const res = await api.get('/classes', {
    params: {
      locationId: params.locationId,
      startDate: params.startDate,
      endDate: params.endDate,
      availableOnly: params.availableOnly,
      limit: params.limit ?? 25,
    },
  });
  return res.data.classes;
}

export async function getClass(classId: string): Promise<ClassDetail> {
  const res = await api.get(`/classes/${classId}`);
  return res.data;
}

export async function createClass(input: CreateClassInput): Promise<{ eventId: string }> {
  const res = await api.post('/classes', input);
  return res.data;
}

export async function updateClass(classId: string, updates: Partial<CreateClassInput> & { status?: string; teacherIds?: string[] }): Promise<void> {
  await api.put(`/classes/${classId}`, updates);
}

export async function activateClass(classId: string): Promise<void> {
  await api.put(`/classes/${classId}`, { status: 'Active' });
}

export async function cancelClass(classId: string, reason?: string): Promise<{ notificationsSent: number }> {
  const res = await api.delete(`/classes/${classId}`, { data: { reason } });
  return res.data;
}

export async function registerForClass(classId: string): Promise<{ status: string; waitlistPosition?: number }> {
  const res = await api.post(`/classes/${classId}/register`);
  return res.data;
}

export async function cancelRegistration(classId: string): Promise<void> {
  await api.delete(`/classes/${classId}/register`);
}

export async function joinWaitlist(classId: string): Promise<{ waitlistPosition: number }> {
  const res = await api.post(`/classes/${classId}/waitlist`);
  return res.data;
}
